'use strict';

/**
 * @module Place
 * @author Philip & Micha
 */

const BaseView = require('./_');
const PlaceTemplate = require('../../templates/place.html');
const TemplateHelper = require('../helpers/template');
const DataHelper = require('../helpers/data');
const ConfigurationHelper = require('../helpers/configuration');
const EventHelper = require('../helpers/event');
const $ = require('zepto');

class Place extends BaseView {
	constructor (parent, place) {
		super({
			parent
		});
		this.place = place;
		this.place.name = this.place.name.replace(/\s*\/\s*/g, '/\u200B'); // add zero width space
		this.meta = {
			selected: place.selected,
			order: Math.round(place.distance / 10),
			bookingButtonLabel: ConfigurationHelper.getString('place.bookingButtonLabel'),
			bookingUrl: ConfigurationHelper.getBookingUrl({place: place}),
			distance: null
		};
	}
	
	async render () {
		const bookeeProducts = await DataHelper.request('getBookeeProductsByBookeeProductIds', {bookeeProductIds: this.place.bookeeProductIds});
		
		this.providerSettings = await DataHelper.request('getProviderSettings');

		bookeeProducts.forEach(bookeeProduct => {
			bookeeProduct.countOnPlace = this.place.bookeeCountByBookeeProductId[bookeeProduct.id] || null;
		});
		
		EventHelper.onPlaceSelect(this, this.handlePlaceSelect);
		
		this.meta.distance = await this.formatDistance(this.place.distance);
		
		TemplateHelper.render({
			view: this,
			template: PlaceTemplate,
			data: {
				meta: this.meta,
				place: this.place,
				bookeeProducts,
				label: this.place.bookeeCount + '&nbsp;' + ConfigurationHelper.getString('place.vehicle' + (this.place.bookeeCount === 1 ? '' : 's'))
			}
		});
	}
	
	handlePlaceSelect (data) {
		if (data.places.includes(this.place.id)) {
			this.selected(true);
		} else {
			this.selected(false);
		}
		
		// scroll list to top.
		if (data.options.single === true) {
			$('.list').scrollTop(0);
		}
	}
	
	updateDistance (distance) {
		this.meta.distance = this.formatDistance(distance);
		this.meta.order = Math.round(distance / 10);
	}
	
	selected (value) {
		if (value === undefined) {
			return this.meta.selected || false;
		}
		this.meta.selected = !!value;
	}
	
	toggle () {
		if (!this.selected()) {
			// sync with map
			EventHelper.selectPlace({
				placeId: this.place.id,
				options: {
					single: false,
					panTo: false
				}
			});
		} else {
			EventHelper.unselectPlace(this.place.id);
		}
	}
	
	formatDistance (d) {
		if (typeof d !== 'number' || d < 0) { return; }
		
		const defaultDistanceUnit = (this.providerSettings || {defaultDistanceUnit: null}).defaultDistanceUnit;

		let t = null;

		if (defaultDistanceUnit === 'STATUTEMILES') {
			const miles = Math.round(d / 160.9344) / 10;

			if (miles === 0) {
				t = '<&#8239;0.1&#8239;miles';
			} else if (miles < 100) {
				t = miles + ((miles === 1) ? '&#8239;mile' : '&#8239;miles');
			} else {
				t = Math.round(miles) + '&#8239;miles';
			}
		
		} else {

			if (d < 1000 && d > 5) {
				t = Math.round(d / 10) + '0&#8239;m';
			}
			else if (d > 10) {
				t = (Math.round(d / 10) * 10 / 1000) + '&#8239;km';
			}
			else {
				t = '<&#8239;10&#8239;m';
			}
		}

		return t;
	}
}

module.exports = Place;
